export async function findStudentClass(data, email) {
  for (const district in data) {
    for (const school in data[district]) {
      for (const className in data[district][school]) {
        if (data[district][school][className]?.includes(email)) {
          return { district, school, className };
        }
      }
    }
  }
  return null;
}
